import { IVehicleStock } from '@common';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UsedVehicleStockState {
  usedVehicleStock: IVehicleStock;
}

const initialState: UsedVehicleStockState = {
  usedVehicleStock: null,
};

const usedVehicleStockSlice = createSlice({
  name: 'usedVehicleStock',
  initialState,
  reducers: {
    setUsedVehicleStock: (state, action: PayloadAction<IVehicleStock>) => {
      state.usedVehicleStock = action.payload;
    },
  },
});

export const { setUsedVehicleStock } = usedVehicleStockSlice.actions;
export default usedVehicleStockSlice.reducer;
